export const PARTNER_EMAIL = 'partner@byggfynd.se';

export const buildPartnerMailto = (
  email = PARTNER_EMAIL,
  subject = 'Anslutning byggvaruhus – ByggFynd',
) => `mailto:${email || PARTNER_EMAIL}?subject=${encodeURIComponent(subject)}`;

export const PARTNER_MAILTO = buildPartnerMailto();

export const PARTNER_COLORS = {
  bg: '#F5F5F5',
  text: '#1F2937',
  textMuted: '#4B5563',
  accent: '#FF7A00',
  accentHover: '#E66D00',
  navy: '#0B1E33',
  border: '#E5E7EB',
};
